import React, { ReactNode } from "react";
import "./websiteBuilderLoadingScreen.scss";
import { useTranslation } from "react-i18next";

interface IWebsiteBuilderLoadingScreenProps {
  children: ReactNode;
}

export function WebsiteBuilderLoadingScreen(props: IWebsiteBuilderLoadingScreenProps) {
  const { children } = props;

  const { t } = useTranslation();
  
  return (
    <div className="website-builder-loading-screen-container">
      {children}
      <div className="loading-screen">
        <div className="loading-screen-content">
          <div className="loading-screen-message">{t("Preparing your website...")}</div>
        </div>
      </div>
    </div>
  );
}